module.exports = __webpack_public_path__ + "static/media/logo-white.b580be95.png";